// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore, collection, doc, getDoc, getDocs ,} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getAnalytics ,  } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAnLEkW9jC2plBOyLK86RNCTuAwdhLOdbg",
  authDomain: "phc-99.firebaseapp.com",
  projectId: "phc-99",
  storageBucket: "phc-99.firebasestorage.app",
  messagingSenderId: "1015835597536",
  appId: "1:1015835597536:web:fb1aab03f49f5b6c354e85",
  measurementId: "G-8QPG058DV4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const analytics = getAnalytics(app);
const auth = getAuth(app);


export { app, db, analytics , auth , collection, doc, getDoc, getDocs };